module.exports = __webpack_public_path__ + "img/radio.9920a5ef.svg";